import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0da63f34"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "40.0004",
  cy: "39.9992",
  r: "33.3333",
  transform: "rotate(-180 40.0004 39.9992)",
  fill: "#7B90FF"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M23.3333 36.3217L35.7142 49.9998L56.6666 26.6665",
  stroke: "white",
  "stroke-width": "7"
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]


export default /*#__PURE__*/_defineComponent({
  name: 'CheckInBlueCircle',
  props: {
    size: null,
    mobileSize: null
  },
  setup(__props: any) {

const props = __props as {
  size?: number;
  mobileSize?: number;
}

_useCssVars(_ctx => ({
  "bb84d972": (getMobileSize())
}))



const getMobileSize = () => {
  const target = props.mobileSize || props.size || 80
  return `${target}px`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size || 80,
    height: __props.size || 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_4, 8, _hoisted_1))
}
}

})